import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { bool, func, string } from 'prop-types';
import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import { createSlug, getListingType } from '../../util/urlHelpers';
import { LISTING_STATE_DRAFT } from '../../util/types';

import Modal from '../Modal/Modal';
import { Button } from '../../components';
import { propTypes } from '../../util/types';

import css from './ProfileUpdatePopup.module.css';

const ProfileUpdatePopup = props => {
  const { isOpen, onClose, onManageDisableScrolling, className, currentUserListing } = props;
  const history = useHistory();
  const {
    id: { uuid: currentListingId } = {},
    attributes: { title: currentListingTitle = '', state: currentListingState } = {},
  } = currentUserListing || {};

  const handleUpdateProfile = () => {
    onClose();
    if (currentListingId) {
      const isDraft = currentListingState === LISTING_STATE_DRAFT;
      history.push(
        createResourceLocatorString(
          'EditListingPage',
          routeConfiguration(),
          {
            id: currentListingId,
            slug: createSlug(currentListingTitle),
            type: getListingType(isDraft),
            tab: 'description',
          },
          {}
        )
      );
    }
  };

  return (
    <Modal
      id="ProfileUpdatePopup.profileUpdateModal"
      className={className}
      containerClassName={css.modalContainer}
      contentClassName={css.content}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
      closeButtonMessage={<FormattedMessage id="ProfileUpdatePopup.closeButton" />}
    >
      <div className={css.modalContent}>
        <h2 className={css.title}>
          <FormattedMessage id="ProfileUpdatePopup.title" />
        </h2>

        <p className={css.description}>
          <FormattedMessage id="ProfileUpdatePopup.description1" />
        </p>

        <p className={css.description}>
          <FormattedMessage id="ProfileUpdatePopup.description2" />
        </p>

        <p className={css.description}>
          <FormattedMessage id="ProfileUpdatePopup.description3" />
        </p>

        <p className={css.contactInfo}>
          <FormattedMessage
            id="ProfileUpdatePopup.contactInfo"
            values={{
              email: (
                <a href="mailto:Connect@boldly.app" className={css.emailLink}>
                  <FormattedMessage id="ProfileUpdatePopup.emailLinkText" />
                </a>
              ),
            }}
          />
        </p>

        <Button className={css.updateProfileButton} type="button" onClick={handleUpdateProfile}>
          <FormattedMessage id="ProfileUpdatePopup.updateProfileButton" />
        </Button>
      </div>
    </Modal>
  );
};

ProfileUpdatePopup.defaultProps = {
  className: null,
  currentUser: null,
  currentUserListing: null,
};

ProfileUpdatePopup.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  className: string,
  currentUser: propTypes.currentUser,
  currentUserListing: propTypes.ownListing,
};

export default ProfileUpdatePopup;
